
import { Component, Prop } from 'nuxt-property-decorator'
import {
  createAmpTranslatedOfferDetailsInstance,
  createTranslatedOfferDetailsInstance,
  createTranslatedOfferBenefitsInstance,
  isMobileDTO,
  MobileOffer,
  TranslatableContext,
} from '@alao-frontend/core'
import OfferCardLayout from '~/components/offers/OfferCard/OfferCardLayout.vue'
import ExpertTip from '~/components/offers/OfferCard/ExpertTip'
import OfferCardDetails from '~/components/offers/OfferCard/OfferCardDetails'
import OfferCardPrice from '~/components/offers/OfferCard/OfferCardPrice.vue'
import { OfferCardMixin } from '~/components/offers/OfferCard/mixins/offer-card.mixin'
import { checkDateLessDays } from '~/utils/check-date-less-days'
import type { TooltipTrigger } from '~/components/AppTooltip.vue'

@Component({
  components: {
    OfferCardLayout,
    ExpertTip,
    OfferCardDetails,
    OfferCardPrice,
  },
})
export default class MobileOfferCard extends OfferCardMixin {
  @Prop({ required: true, default: () => ({}), type: Object })
  protected readonly offer!: MobileOffer

  @Prop({ required: false, type: Boolean, default: true })
  clickable!: boolean

  @Prop({
    default: 'hover',
    type: String,
  })
  readonly pricesTooltipTrigger!: TooltipTrigger

  protected readonly details = isMobileDTO(this.offer.dto)
    ? createTranslatedOfferDetailsInstance(
      this.offer,
      this.$i18n as TranslatableContext,
    )
    : createAmpTranslatedOfferDetailsInstance(
      this.offer,
      this.$i18n as TranslatableContext,
    )

  protected readonly benefits = createTranslatedOfferBenefitsInstance(
    this.offer,
    this.$i18n as TranslatableContext,
  )

  protected checkDateLessDays = checkDateLessDays

  get endDateInFewDays () {
    if (!this.offer.endDate) {
      return this.offer.endDate
    }

    return checkDateLessDays(this.offer.endDate) ? this.offer.endDate : null
  }
}
